import { z } from 'zod';

export const mediaAssetSchema = z.object({
  id: z.string(),
  siteId: z.string(),
  key: z.string().min(1),
  contentType: z.string().min(1),
  sizeBytes: z.number().int().min(0),
  width: z.number().int().min(0).optional(),
  height: z.number().int().min(0).optional(),
  filename: z.string().max(255).optional(),
  createdAt: z.string(),
});
